import axios from 'axios';
import { consoleLog} from "./log";

const AWS_API_BASE_URL = process.env.REACT_APP_AWS_API_BASE_URL;
const API_KEY = process.env.REACT_APP_AWS_API_KEY;

export function updateFreeeRefreshToken(freeeAccessToken, freeeRefreshToken) {
  const updateRefreshTokenURL = AWS_API_BASE_URL + '/api/auth/refresh_token';
  const updateRefreshTokenRequestData = {
    'freee_access_token': freeeAccessToken,
    'freee_refresh_token': freeeRefreshToken
  }
  const updateRefreshTokenConfig = {
    method: 'post',
    headers: {
      'content-type': 'application/json',
      'x-api-key': API_KEY
    },
    data: updateRefreshTokenRequestData,
    url: updateRefreshTokenURL
  };
  axios(updateRefreshTokenConfig).then((response) => {
    consoleLog('freeeのリフレッシュトークンの更新に成功しました')
  }).catch( (error) => {
    consoleLog('freeeのリフレッシュトークンの更新に失敗しました');
  });
}

export function updateGsuiteRefreshToken(freeeAccessToken, gsuiteRefreshToken) {
  const updateRefreshTokenURL = AWS_API_BASE_URL + '/api/auth/gsuite_refresh_token';
  const updateRefreshTokenRequestData = {
    'freee_access_token': freeeAccessToken,
    'gsuite_refresh_token': gsuiteRefreshToken
  }
  const updateRefreshTokenConfig = {
    method: 'post',
    headers: {
      'content-type': 'application/json',
      'x-api-key': API_KEY
    },
    data: updateRefreshTokenRequestData,
    url: updateRefreshTokenURL
  };
  axios(updateRefreshTokenConfig).then((response) => {
    consoleLog('GSuiteのリフレッシュトークンの更新に成功しました')
  }).catch( (error) => {
    consoleLog('GSuiteのリフレッシュトークンの更新に失敗しました');
  });
}